<div class="row p-0 contenedor-detalle-siniestro mx-1 mt-2">
  @if (!ocultarCoberturasAsegurado) {
    <div class="my-3"
      [ngClass]="!ocultarCoberturasTercero ? 'col-lg-6 col-md-12 col-sm-12 col-12 borde-derecho' : 'col-md-12 col-12'"
      >
      <div class="row borde-inferior">
        <div class="col-md-12 col-12">
          <small class="titulo">COBERTURAS</small>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12 my-4 overflow-auto p-0">
          <div class="seccion-tabla">
            <table mat-table multiTemplateDataRows [dataSource]="listCoberturas"
              class="table d-xl-table d-md-table d-table table-responsive my-2">
              <ng-container matColumnDef="ClaveCobertura" [sticky]="true">
                <th mat-header-cell class="px-2" *matHeaderCellDef>Cobertura</th>
                <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.cve_coberturak}}</td>
              </ng-container>
              <ng-container matColumnDef="Descripcion">
                <th mat-header-cell class="px-2" *matHeaderCellDef>Descripción</th>
                <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_cobertura}}</td>
              </ng-container>
              <ng-container matColumnDef="Estimacion">
                <th mat-header-cell class="px-2" *matHeaderCellDef>Estimación</th>
                <td mat-cell *matCellDef="let element" class="mx-1">{{element?.estimado}}</td>
              </ng-container>
              <ng-container matColumnDef="Deducible">
                <th mat-header-cell class="px-2" *matHeaderCellDef>Deducible</th>
                <td mat-cell *matCellDef="let element" class="mx-1">{{element?.deducible | currency}}</td>
              </ng-container>
              <ng-container matColumnDef="PorcDeducible">
                <th mat-header-cell class="px-2" *matHeaderCellDef>Porc. Deducible</th>
                <td mat-cell *matCellDef="let element" class="mx-1">{{element?.porc_deduc}}</td>
              </ng-container>
              <ng-container matColumnDef="ConDeducible">
                <th mat-header-cell class="px-2" *matHeaderCellDef>Deducible</th>
                <td mat-cell *matCellDef="let element" class="mx-1">{{procesaDeducible(element) }}</td>
              </ng-container>
              <ng-container matColumnDef="Ver">
                <th mat-header-cell class="px-2" *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="mx-1">
                  @if (element?.cve_coberturak == 3 ||  element?.cve_coberturak == 96) {
                    <i class="far fa-file-alt" (click)="abrirModalDetalleCobertura(element)"></i>
                  }
                </td>
              </ng-container>
              <!-- Sin resultados -->
              <ng-container matColumnDef="noData">
                <td mat-footer-cell *matFooterCellDef colspan="7">
                  <small>No se encontró ningún resultado</small>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="SelectRow(row, 'COBERTURA')"
              [ngClass]="{'highlightTableColor': selectedCoberturaRowIndex == row.cve_coberturak }"> </tr>
              <tr mat-footer-row *matFooterRowDef="['noData']"
              [ngClass]="(listCoberturas?.data?.length === 0) ? '':'ocultarPaginator'"></tr>
            </table>
            <mat-paginator #coberturas [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons
              [length]="listCoberturas?.data?.length" aria-label="Select page of periodic elements"
              [ocultarLabelPagina]="!ocultarCoberturasAsegurado"
              [ocultarInputPagina]="!ocultarCoberturasAsegurado" appOcultaElementosPaginador>
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!ocultarCoberturasTercero) {
    <div class="borde-derecho my-3"
      [ngClass]="!ocultarCoberturasAsegurado ? 'col-lg-6 col-md-12 col-sm-12 col-12' : 'col-md-12 col-12'"
      >
      <div class="row borde-inferior">
        <div class="col-md-12 col-12">
          <small class="titulo">TERCEROS</small>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12 my-4 overflow-auto">
          <div class="seccion-tabla">
            <table mat-table multiTemplateDataRows
              [dataSource]="datosTerceros.data | slice:(paginatorInfo?.pageStart ? paginatorInfo?.pageStart - 1 : 0):paginatorInfo?.pageEnd"
              class="table d-xl-table d-md-table d-table table-responsive my-2">
              <ng-container matColumnDef="TipoTercero">
                <th mat-header-cell class="px-2" *matHeaderCellDef>TipoTercero</th>
                <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.desc_tipo_tercero}}</td>
              </ng-container>
              <ng-container matColumnDef="Nombre">
                <th mat-header-cell class="px-2" *matHeaderCellDef>Nombre</th>
                <td mat-cell *matCellDef="let element" class="mx-1">{{element?.nombre_completo}}</td>
              </ng-container>
              <ng-container matColumnDef="Serie">
                <th mat-header-cell class="px-2" *matHeaderCellDef>Serie</th>
                <td mat-cell *matCellDef="let element" class="mx-1">{{element?.serie}}</td>
              </ng-container>
              <ng-container matColumnDef="Estatus">
                <th mat-header-cell class="px-2" *matHeaderCellDef>Estatus</th>
                <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_estatus_tercero}}</td>
              </ng-container>
              <ng-container matColumnDef="Importe">
                <th mat-header-cell class="px-2" *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="mx-1">
                  @if (procesaImporte(element) != '') {
                    <i class="far fa-file-alt"
                      [matTooltip]="'Reserva precautoria ' + procesaImporte(element) "
                      matTooltipPosition="above">
                    </i>
                  }
                </td>
              </ng-container>
              <!-- Sin resultados -->
              <ng-container matColumnDef="noData">
                <td mat-footer-cell *matFooterCellDef colspan="5">
                  <small>No se encontró ningún resultado</small>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayColumnsTercero"></tr>
              <tr mat-row *matRowDef="let row; columns: displayColumnsTercero;"
                (click)="SelectRow(row, 'TERCEROS')"
                [ngClass]="{'highlightTableColor': selectedCoberturaRowIndexTercero == row.id_tercero }">
              </tr>
              <tr mat-footer-row *matFooterRowDef="['noData']"
                [ngClass]="(datosTerceros?.data?.length === 0) ? '':'ocultarPaginator'">
              </tr>
            </table>
            <app-pagina-datos-tabla (eventPaginator)="paginatorInfo = $event" (click)="$event.stopPropagation()"
              [style.visibility]="datosTerceros?.data?.length >= 6 ? 'visible' : 'hidden'"
              [showFisrtLastButton]="true" [registerPerPage]="5" [totalLength]="datosTerceros?.data?.length">
            </app-pagina-datos-tabla>
          </div>
        </div>
      </div>
    </div>
  }
</div>